import React, { useEffect, useState, useRef } from "react";
import "./LoaderComponent.css";

export default function LoaderComponent({ time, onClickSubmit, tag, code, filterToggle }) {
    const [count, setCount] = useState(time);
    const [showLoader, setShowLoader] = useState(true);
    const apiCalled = useRef(false); // ✅ Prevent duplicate API calls

    useEffect(() => {
        setCount(time);
        setShowLoader(true);
        apiCalled.current = false; // ✅ Reset API tracking on every new timer

        const timer = setInterval(() => {
            setCount(prevCount => {
                if (prevCount <= 1) {
                    clearInterval(timer);
                    setShowLoader(false);
                    filterToggle(false);

                    if (!apiCalled.current) {
                        apiCalled.current = true; // ✅ Mark API as triggered to prevent second call
                        onClickSubmit(code, null, tag);
                    }
                    return 0; // ✅ Ensure count never goes below 0
                }
                return prevCount - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [time]);

    return (
        <div className="loaderContainer">
            <p>{count}</p>
            {showLoader && (
                <div id="loader-wrapper">
                    <div className="loader"></div>
                </div>
            )}
        </div>
    );
}
